<template>
    <div class="bread">
        <!-- 表格 -->
        <template v-if="tableData.length>0">
            <div id="brokenLineChart"
                 ref="brokenLine"
                 class="brokenLineChart"
                 :style="{width: isMobile ? '355px' : '100%', height: isMobile ? (h + 'px') : '100%'}"></div>
        </template>

        <template v-if="tableData.length === 0">
            <div class="nodata">
              <span>
                <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
                <div>暂无数据</div>
              </span>
            </div>
        </template>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import {chartParse, colorData} from "./js/color";
let chartsModel = "";
// var curInt = null;


export default {
    name: 'brokenLineDetails',
    props: {
      h: Number,
        isMobile: {
          type: Boolean,
          default: false
        },
        //- 分组字段数据
        row: {
            type: Array,
            default: ()=>[]
        },
        //- 汇总字段数据
        summary: {
            type: Array,
            default: ()=>[]
        },
        //- drage组件大小修改后，饼图实时更新
        changeSize: {
            type: Number,
            default: 0
        },
        //- 表格数据
        tableData: {
            type: Array,
            default: ()=>[]
        },
        //- 表id
        id: {
            type: Number,
            default: 0
        },
        //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
        isFrontEnd: {
            type: Boolean,
            default: ()=>false
        },
        selectIndex: {
            type: Number,
            default: ()=>null
        },
      user: {
        type: Array,
        default: () => []
      },
      viewShow: {
        type: Boolean,
        default: false
      },
      width: [String, Number],
      theme: Object,
      column: {
        type: Array,
        default: () => []
      }
    },
    data: function () {
        return {
            myChart: '',
            nameArray: [],
        }
    },
    mounted() {
        console.log("this.selectIndex==>",this.selectIndex);
        // if(this.selectIndex){
        //     curInt = this.selectIndex;
        // }
        this.$nextTick(()=>{
            this.openFunBread();
        })
    },
    methods: {
        updateFun(){
            console.log("更新");
          if (this.myChart.resize) this.myChart.resize();
        },
        //- 打开图表
        openFunBread(){
            console.log("openFun",this.tableData.length);
            if(this.tableData.length <= 25 && this.tableData.length > 0){
                this.$nextTick(()=>{
                    this.initData();
                })

            }

        },
      // series 值动态计算
      getSeries () {
        const series = []
        for (const i of this.summary) {
          const arr = this.tableData.map(its => its[i.title])
          if (this.theme && this.theme.axes) {
            series.push({
              data: arr,
              type: 'line',
              symbol: this.theme.symbol,
              symbolSize: this.theme.symbolSize,
              symbolBorderWidth: this.theme.symbolBorderWidth,
              smooth: this.theme.lineSmooth,
              // 线条颜色
              lineStyle: {
                // color: this.theme.color[0],
                width: this.theme.lineWidth
              },
              // 小圆点颜色
              itemStyle: {
                // color: this.theme.color[0],
                borderWidth: this.theme.symbolBorderWidth,
                type: 'solid',
              },
              // 最大值气泡效果
              // markPoint: {
              //   data: [{type:"max", name: ''}]
              // }
            })
          } else {
            series.push({
              data: arr,
              type: 'line',
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#80E0FF'
                }
              },
              lineStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(1,0,0,1,[{offset:0, color: '#80E0FF'}, {offset:1, color: '#50BEE2'}], false)
                }
              }
            })
          }
        }
        return series
      },
        //- 创建图表
        initData() {
            const that = this;
          let nameArray = []
          if (this.column && this.column.length > 0) {
            for (const i of this.tableData) {
              if (Array.isArray(i)) {
                for (const s of i) {
                  if (s) nameArray.push(s.name)
                }
              }
            }
            nameArray = Array.from(new Set(nameArray))
          } else {
            nameArray = this.tableData.map(val=>{
              return val.name
            })
          }

            chartsModel = "";
            // that.tableData[0].selected = true;
            that.$nextTick(()=>{
                 // 基于准备好的dom，初始化echarts实例
                let dom = that.$refs.brokenLine;
                if (!dom) return
                echarts.registerTheme('macarons', macaronsDatas.theme)
                chartsModel = echarts.init(dom,'macarons');

                const config = {
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#80E0FF'
                    }
                  },
                  lineStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(1,0,0,1,[{offset:0, color: '#80E0FF'}, {offset:1, color: '#50BEE2'}], false)
                    }
                  }
                }
                let option = {
                  tooltip: {
                    trigger: this.theme.markTextAllShow === 'all' ? 'axis' : 'item',
                    backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
                    textStyle: {
                      color: "#333",
                      width: 'auto',
                      overflow: 'break',  // 超出宽度后自动换行
                      lineHeight: 24
                    },
                    confine: true,  // 确保tooltip不会超出图表区域
                  },
                  legend: {
                    type: 'scroll',
                    top: 'top',
                    show: true,
                    textStyle: {
                      color: this.theme.legendTextColor,
                      fontSize: this.theme.legendTextFontSize,
                      fontFamily: this.theme.legendTextFontFamily
                    }
                  },
                    xAxis: {
                        type: 'category',
                        data: nameArray,
                        axisLabel: {
                            interval: 0,
                            formatter:function(value)
                            {
                              if (value && typeof value === "string") value = value.split(/\1{1}/g).join('')
                              var ret = "";//拼接加\n返回的类目项
                                var maxLength = 5;//每项显示文字个数
                                var valLength = value.length;//X轴类目项的文字个数
                                var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                                if (rowN > 1)//如果类目项的文字大于3,
                                {
                                    for (var i = 0; i < rowN; i++) {
                                        var temp = "";//每次截取的字符串
                                        var start = i * maxLength;//开始截取的位置
                                        var end = start + maxLength;//结束截取的位置
                                        //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                                        temp = value.substring(start, end) + "\n";
                                        ret += temp; //凭借最终的字符串
                                    }
                                    return ret;
                                }
                                else {
                                    return value;
                                }
                            },
                            color: '#666666'
                        },
                        axisTick: {
                          show: true,
                          alignWithLabel: true
                        },
                        axisLine: {
                          show: true,
                          lineStyle: {
                            color: '#D8D8D8'
                          }
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                          color: '#999999'
                        },
                        // 刻度设置
                        axisTick: {
                          show: true,
                          alignWithLabel: true
                        },
                        axisLine: {
                          show: true,
                          lineStyle: {
                            color: '#D8D8D8'
                          }
                        },
                        splitLine: {
                          show: false,
                          lineStyle: {
                            color: '#D8D8D8'
                          }
                        }
                    },
                  grid:{
                    top: this.column.length > 0 ? 45 : 20,
                    bottom: 20,
                    left: 20,
                    right: 20,
                    containLabel: true
                  },
                  series: this.column.length > 0 ? chartParse({
                    date: this.tableData, column: this.column, summary: this.summary, xAxisData: nameArray, config: config, colorFu: this.theme && this.theme.axes ? this.theme.color : colorData
                  }) : this.getSeries()

                  // series: this.getSeries()
/*
                  series: [{
                        data: valueArray,
                        type: 'line',
                        smooth: true,
                        // label: {
                        //   normal: {
                        //     show: true,
                        //     position: 'top',
                        //     textStyle: {
                        //       color: '#999999'
                        //     }
                        //   }
                        // },
                        itemStyle: {
                          normal: {
                            color: '#80E0FF'
                            // color: '#999999'
                          }
                        },
                        lineStyle: {
                          normal: {
                            color: new echarts.graphic.LinearGradient(1,0,0,1,[{offset:0, color: '#80E0FF'}, {offset:1, color: '#50BEE2'}], false)
                          }
                        }
                    }]
*/
                };
              if (this.theme && this.theme.axes) {
                const axisIndex = this.theme.axes.findIndex(its => its.type === 'category')
                const axis = this.theme.axes[axisIndex]
                console.log('x轴数据', nameArray, axis, axisIndex, this.theme.axes)

                option.color = this.theme.color
                option.legend = {
                  show: this.theme.legendTextShow,
                  textStyle: {
                    color: this.theme.legendTextColor,
                    fontSize: this.theme.legendTextFontSize,
                    fontFamily: this.theme.legendTextFontFamily
                  }
                }
                option.tooltip = {
                  trigger: this.theme.markTextAllShow === 'all' ? 'axis' : 'item',
                  backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
                  textStyle: {
                    color: "#333",
                    width: 'auto',
                    overflow: 'break',  // 超出宽度后自动换行
                    lineHeight: 24
                  },
                  confine: true,  // 确保tooltip不会超出图表区域
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                }
                option.xAxis.axisLine.show = axis.axisLineShow
                option.xAxis.axisLine.lineStyle.color = axis.axisLineColor
                option.yAxis.axisLine.show = axis.axisLineShow
                option.yAxis.axisLine.lineStyle.color = axis.axisLineColor
                option.xAxis.axisTick.show = axis.axisTickShow
                option.xAxis.axisTick.lineStyle = {color: axis.axisTickColor}
                option.yAxis.axisTick.show = axis.axisTickShow
                option.yAxis.axisTick.lineStyle = {color: axis.axisTickColor}

                option.xAxis.axisLabel.rotate = this.theme.textRotate
                option.xAxis.axisLabel.show = axis.axisLabelShow
                option.xAxis.axisLabel.color = axis.axisLabelColor
                option.xAxis.axisLabel.fontFamily = axis.axisLabelFontFamily
                option.xAxis.axisLabel.fontSize = axis.axisLabelFontSize
                option.yAxis.axisLabel.show = axis.axisLabelShow
                option.yAxis.axisLabel.color = axis.axisLabelColor
                option.yAxis.axisLabel.fontFamily = axis.axisLabelFontFamily
                option.yAxis.axisLabel.fontSize = axis.axisLabelFontSize
                // 没设置文字倾斜的时候，x坐标文字根据画布自适应显示
                if(this.theme.textRotate == 0 || this.theme.textRotate == undefined){
                  option.xAxis.axisLabel.interval = 'auto'
                }
                option.xAxis.splitLine = {
                  show: axis.splitLineShow,
                  lineStyle: {
                    color: axis.splitLineColor,
                  }
                }
                option.yAxis.splitLine = {
                  show: axis.splitLineShow,
                  lineStyle: {
                    color: axis.splitLineColor,
                  }
                }
                option.legend.top = this.theme.legendPosition
                if(option.legend.top === 'top'){
                  option.grid.top = 45
                  option.grid.bottom = 20
                }
                else{
                  option.grid.top = 20
                  option.grid.bottom = 45
                }

/*
                option.series = [{
                  data: this.tableData,
                  type: 'line',
                  symbol: this.theme.symbol,
                  symbolSize: this.theme.symbolSize,
                  symbolBorderWidth: this.theme.symbolBorderWidth,
                  smooth: this.theme.lineSmooth,
                  // 线条颜色
                  lineStyle: {
                    color: this.theme.color[0],
                    width: this.theme.lineWidth
                  },
                  // 小圆点颜色
                  itemStyle: {
                    color: this.theme.color[0],
                    borderWidth: this.theme.symbolBorderWidth,
                    type: 'solid',
                  },
                  // 最大值气泡效果
                  markPoint: {
                    data: [{type:"max", name: ''}]
                  }
                }]
*/
                // delete option.series[0].itemStyle
              }

              chartsModel.clear();
                // 绘制图表
                chartsModel.setOption(option);
                chartsModel.off("click");
                chartsModel.on("click", (param)=>{
                    //- 设置折线图点击事件
                    if(that.isFrontEnd === true){
                        return;
                    }
                    console.log("折线图点击=====>",param);


                    that.relevanceFun(param.name,param.value,param.dataIndex);
                });
                that.myChart = chartsModel;
                that.$forceUpdate();
            })
        },
        //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
        relevanceFun(name,val,index){
            if(this.isFrontEnd === true){
                return;
            }
            let rowName = this.row[0].name;
            let summaryName = this.summary[0].name;
            let array = {};
            const nameArr = name ? name.split(/\1{1}/g) : name;
            if (Array.isArray(nameArr)) {
              for (let i = 0; i < this.row.length; i++) {
                array[this.row[i].name] = nameArr[i]
              }
            } else {
              array[rowName] = nameArr;
            }
            array[summaryName] = val;
            let date = {
                id: this.id,
                value: array,
                selectIndex: index
            }
          if (this.user[index]) date.user = this.user[index]
            this.$emit("relevanceFun",date)
        }
    },
    watch: {
        changeSize(val) {
            console.log("w===>",val)
            if(this.tableData.length>0){
                setTimeout(() => {
                    this.updateFun();

                }, 1000);

            }

        },
        'tableData':{
            handler (newV) {
                // do something, 可使用this
                console.log(newV)
                if(newV && newV.length>0){
                    this.$nextTick(()=>{
                        this.$forceUpdate();
                        this.openFunBread();
                    })
                }

            },
            deep:true

        },
        'selectIndex': {
            handler(newName) {

                console.log("变话了",newName)
                this.$nextTick(()=>{
                    this.$forceUpdate();
                    this.initData();
                })
            },
            deep:true
        },
        viewShow: {
          immediate: true,
          handler () {
            this.updateFun()
          }
        },
      width: {
        immediate: true,
        handler () {
          this.updateFun()
        }
      },
      theme: {
        deep: true,
        handler () {
          console.log('配置更新')
          // this.$forceUpdate();
          this.initData();
        }
      },
    }
}
</script>

<style scoped lang="scss">
.bread {
    width: 100%;
    height: 100%;
    position: relative;

}
.nodata {
    width: 100%;
    text-align: center;
    color: #666666;
    //line-height: 244px;
    height: 100%;
    position: relative;
    span{
        display: inline-block;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        margin-left: -29px;

    }
}





</style>
